import { cn } from '@/shared/lib/cn'

/** Variantes del logo disponibles en /public/brand/. */
export type LogoVariant = 'icon' | 'full' | 'text-only'

export interface LogoProps {
  /**
   * - `icon`      → logo-die.png (solo el dado, cuadrado)
   * - `full`      → logo-lockup.png (dado + nombre)
   * - `text-only` → logo-wordmark.png (nombre sin dado)
   *
   * @default 'full'
   */
  variant?: LogoVariant
  /** Clases Tailwind adicionales aplicadas al <img>. */
  className?: string
  /** Texto alternativo. Por defecto "Matchplay". */
  alt?: string
}

/** Fichero + dimensiones intrínsecas (px reales del PNG) → el navegador reserva
 *  el hueco antes de cargar la imagen y evita el salto de layout (CLS). */
const VARIANT_FILE: Record<LogoVariant, { src: string; width: number; height: number }> = {
  icon: { src: '/brand/logo-die.png', width: 1311, height: 1317 },
  full: { src: '/brand/logo-lockup.png', width: 1500, height: 478 },
  'text-only': { src: '/brand/logo-wordmark.png', width: 1200, height: 299 },
}

/**
 * Renderiza el logo de Matchplay en tres variantes.
 *
 * @example
 * // Header: logo completo
 * <Logo variant="full" className="h-8" />
 *
 * // Favicon/avatar: solo icono
 * <Logo variant="icon" className="h-10 w-10" />
 *
 * // Footer: solo nombre
 * <Logo variant="text-only" className="h-6" />
 */
export function Logo({ variant = 'full', className = '', alt = 'Matchplay' }: LogoProps) {
  const { src, width, height } = VARIANT_FILE[variant]
  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      // `w-auto` por defecto: con los atributos width/height el ancho sigue a la
      // altura de la clase en vez de pintarse a 1500px. El caller lo puede pisar.
      className={cn('w-auto', className)}
      draggable={false}
    />
  )
}
